export default theme => ({
  groupHeaderWrapper: {
    display: 'flex',
    alignItems:'center',
    marginBottom: 16,
  },
  groupHeader: {
    color: 'black',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '2px 8px',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    minHeight: 34,
    width: 210,
    border: '1px solid'
  },
  groupHeaderDragging: {
    opacity: 0.6,
  },
  groupHeaderText: {
    flex: 1,
    fontWeight: 600,
  },
  dragIcon: {
    marginRight: 20,
  },
  line: {
    background: `repeating-linear-gradient(to left,
      #ccc, #ccc 8px,
      white 8px, white 16px
    );`,
    height: 1,
    display: 'flex',
    flexGrow: 1,
  }
});